import React, { useState, useEffect } from 'react';
import Button from '../../../components/common-components/button/Button';
import { BUTTON_VARIANTS } from '../../../components/common-components/button/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, setABHAAddressUpdateOpen, setABHAProfilePicture, setABHAsuggestedAddress, setABHASuggestionsOpen,setCreateABHApatientRespose,setDownloadedCard,setOpenUpdateABHAValidateOtpModal, setSelectedABHAAddress, setUpdatedABHAEmail, setUpdatedABHAMobile } from '../../../pages/Patients/AddPatient/AddPatientSlice';
import Input from '../../../components/common-components/input/Input';
import Avatar from '../../../components/common-components/avatar';
import TextArea from '../../../components/common-components/textArea/TextArea';
import { abhaAddressSuggetions, abhaAddressUpdate, createABHAPatient, downloadCard } from '../../../pages/Patients/AddPatient/AddPatientSaga';
import UpdateABHAAddressPopup from './updateABHAAddressPopup';
import General from '../../../libs/utility/General';
import SelectDropdown from '../../../components/common-components/selectDropdown';
import { ABHA_UPDATE_OPTIONS } from './Constants';
import { Formik, Form } from 'formik';
import UpdateABHADetails from './UpdateABHADetails';
import UpdateABHAValidateOTPModal from './UpdateABHAValidateOtpModal';
import UploadProfilePictureModal from './UploadProfilePictureModal';
import Checkbox from '../../../components/common-components/checkbox/Checkbox';
import Label from '../../../components/common-components/label/Label';
import UpdateABHAAddressModal from './UpdateABHAAddressModal';
import Icons from '../../../components/icons/Icons';
import ModalComponent from '../../../components/common-components/modal/ModalComponent';
function PatientDetailsReviewModal({ open, onSubmit, close }) {
    const { 
        createPatientData,
        createPatientFromAadhaar, 
        openGetOrCreatePatientModal, 
        transactionIdAndAadhaar, 
        createABHAPatientResponse,
        abhaSuggestedAddress, 
        abhaSuggestionsOpen, 
        abhaAddressUpdateOpen, 
        selectedABHAAddress, 
        updatedABHAEmail, 
        updatedABHAMobile, 
        abhaProfilePicture,
        openUpdateABHAValidateOtpModal, 
        downloadedCardBuffer ,
        selectedABHAOption
    } = useSelector(state => state[componentKey]);
    const dispatch = useDispatch();
    const {
        firstName,
        middleName,
        lastName,
        profilePicture,
        dob,
        gender,
        abhaNumber
    } = createPatientFromAadhaar?.patient || createPatientFromAadhaar?.newPatientData?.patient || {};
    const address = createPatientFromAadhaar?.address || "";
    const [abhaAddressValue, setABHAAddressValue] = useState("");
    const [confirmUpdateABHAAddressOpen, setConfirmUpdateABHAAddressOpen] = useState(false);
    const [abhaAddressToDisplay, setAbhaAddressToDisplay] = useState("");
    const [abhaEmailToDispplay, setABHAEmailToDisplay] = useState("");
    const [abhaMobileToDispplay, setABHAMobileToDisplay] = useState("");
    const [abhaProfilePictureToDisppay, setABHAProfilePictureToDisplay] = useState("");
    const [updateOption, setUpdateOption] = useState({ label: "Select update option", value:""});
    const [updateInputValue, setUpdateInputValue] = useState("");
    const [openUpdateABHAOtpRequest, setOpenUpdateABHAOtpRequest] = useState("false");
    const [openEditProfilePicture, setOpenEditProfilePicture] = useState(false);

    useEffect(() => {
        if(createABHAPatientResponse.success){
            onSubmit()
        }
    }, [createABHAPatientResponse.success, onSubmit])

    useEffect(() => {
        if (createPatientFromAadhaar?.patient?.abhaAddress || createPatientFromAadhaar?.newPatientData?.patient?.abhaAddress) {
            setAbhaAddressToDisplay(createPatientFromAadhaar?.patient?.abhaAddress || createPatientFromAadhaar?.newPatientData?.patient?.abhaAddress);
        }
        if(createPatientFromAadhaar?.patient?.mobileNumber || createPatientFromAadhaar.newPatientData?.patient?.mobileNumber) {
            setABHAMobileToDisplay(createPatientFromAadhaar?.patient?.mobileNumber || createPatientFromAadhaar?.newPatientData?.patient?.mobileNumber)
        }
        if(createPatientFromAadhaar?.patient?.email || createPatientFromAadhaar.newPatientData?.patient?.email) {
            setABHAEmailToDisplay(createPatientFromAadhaar?.patient?.email || createPatientFromAadhaar?.newPatientData?.patient?.email)
        }
        if(createPatientFromAadhaar?.patient?.profilePicture || createPatientFromAadhaar?.newPatientData?.patient?.profilePicture){
            setABHAProfilePictureToDisplay(createPatientFromAadhaar?.patient?.profilePicture || createPatientFromAadhaar?.newPatientData?.patient?.profilePicture)
        }
        return () => {
            dispatch(setABHAsuggestedAddress(""))
            dispatch(setABHASuggestionsOpen(false));
            dispatch(setSelectedABHAAddress(""))
            dispatch(setUpdatedABHAEmail(""))
            dispatch(setUpdatedABHAMobile(""))
            dispatch(setABHAProfilePicture(null))
            dispatch(setDownloadedCard(null))
            dispatch(setABHAAddressUpdateOpen(false))
        }
    }, [createPatientFromAadhaar,dispatch]);
    
    useEffect(() => {
        if (selectedABHAAddress?.preferredAbhaAddress) {
            setAbhaAddressToDisplay(selectedABHAAddress.preferredAbhaAddress);
        }
    }, [selectedABHAAddress]);

    useEffect(() => {
        if(updatedABHAEmail?.email){
            setABHAEmailToDisplay(updatedABHAEmail.email)
        }
    }, [updatedABHAEmail])

    useEffect(() => {
        if(updatedABHAMobile?.mobile){
            setABHAMobileToDisplay(updatedABHAMobile.mobile)
        }
    }, [updatedABHAMobile])

    useEffect(() => {
        if(abhaProfilePicture?.data?.profilePicture) {
            setABHAProfilePictureToDisplay(abhaProfilePicture?.data?.profilePicture)
        } else if(abhaProfilePicture?.encodeBase64) {
            setABHAProfilePictureToDisplay(abhaProfilePicture?.encodeBase64)
        }
    }, [abhaProfilePicture])

    const handleUpdateABHAAddress = async( abhaAddress) => {
        try{
            const payload = {
                txnId: transactionIdAndAadhaar?.transactionId || '',
                abhaAddress: abhaAddress

            }
            await dispatch(abhaAddressUpdate({abhaAddressUpdateData:payload}))

        } catch (error){
            console.log("Error in suggested address", error)
        } finally {
            setUpdateOption({ label: "Select update option", value:""})
            dispatch(setABHAAddressUpdateOpen(false))
            setConfirmUpdateABHAAddressOpen(false)
            dispatch(setABHASuggestionsOpen(false));
        }
    }

    const handleSelectAddress = (abhaAddress) => {
        setConfirmUpdateABHAAddressOpen(true);
        setABHAAddressValue(abhaAddress)
    };
    
    const handleSuggestedABHAAddress = async() => {
        const makeAPICall = !abhaSuggestionsOpen;
        if(makeAPICall){
            try{
                const payload = {
                    txnId: transactionIdAndAadhaar?.transactionId || '',
                }
                await dispatch(abhaAddressSuggetions({abhaAddressSuggetionData:payload}))
                
            } catch (error){
                console.log("Error in suggested address", error)
            }
        }else{
            dispatch(setABHASuggestionsOpen(false));
        }
    }

    const handleDownloadCard = async () => {
        try {
            const payload = {
                xtoken : createPatientFromAadhaar?.patient?.xtoken || createPatientFromAadhaar?.newPatientData?.patient?.xtoken || '',
                key: selectedABHAOption==="Aadhaar Number"?"aadharNumber":selectedABHAOption.toLowerCase().split(' ').map((word, index) => index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)).join('') || "aadharNumber"
            };
            await dispatch(downloadCard({downloadCardData: payload}));
        } catch (error) {
            console.error("Error downloading card:", error);
        }
    };

    // const handleCreateABHApatient = (force=false) => {
    //     const combined = {
    //         providerId: createPatientData.providerId,
    //         ...createPatientFromAadhaar.patient,
    //         address: createPatientFromAadhaar.address,
    //     };
    //     dispatch(createABHAPatient({data:combined, force}))
    // }

    const handleCreateABHApatient = (force = false) => {
		const hasNewPatientData = !!createPatientFromAadhaar?.newPatientData;

		const combined = {
			providerId: createPatientData?.providerId,
			...(hasNewPatientData
				? createPatientFromAadhaar?.newPatientData?.patient
				: createPatientFromAadhaar?.patient),

			address: hasNewPatientData
				? createPatientFromAadhaar?.newPatientData?.address
				: createPatientFromAadhaar?.address,
		};

		dispatch(createABHAPatient({ data: combined, force }));
	};

    useEffect(() => {
        const handleDownloadCard = async (bufferData) => {
            await General.downloadFile(bufferData, 'Patient_Card.png', 'image/png');
        };

        if (downloadedCardBuffer !== null) {
            handleDownloadCard(downloadedCardBuffer.data);
        }
    }, [downloadedCardBuffer]);
    
    function formatDOB(dob) {
        if (typeof dob !== "string") {
          return dob;
        }
      
        const isoDate = Date.parse(dob);
        if (!isNaN(isoDate)) {
          return new Date(isoDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        }

        const [day, month, year] = dob.split('-').map(Number);
        if (day && month && year) {
          const parsedDate = new Date(year, month - 1, day);
          return parsedDate.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        }
        return dob;
      }

    if (!open) {
        return null;
    }
    const {newPatientData,oldPatientData, patient}=createPatientFromAadhaar;
    const {encodeBase64}=newPatientData?.patient||patient
    const {addressLine1,addressLine2,city,state,country,zip}=newPatientData?.address||address

    return(
        <Formik
            initialValues={{
                firstName: '',
                lastName: '',
                gender: '',
                mobileNumber: '',
                updateOption: '',
            }}
            onSubmit={() => {}}
        >
            {({ values, errors, touched, handleChange }) => {
            return (
                <>
                    <div className="fixed inset-0 z-50 flex justify-center items-center bg-gray-800 bg-opacity-50">
                        <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-[700px] max-h-screen overflow-y-auto">
                            <div className="flex justify-between items-center border-b pb-3">
                                <h2 className="text-lg font-semibold">Ayushman Bharat Health Account Details</h2>
                                <div className="flex justify-end items-center-b pb-3 hover:cursor-pointer" onClick={close}>
                                    <Icons iconName={"closeIcon"}/>
                                </div>
                            </div>
                            <div className=' flex justify-between mt-4 mb-8'>
                            {openGetOrCreatePatientModal !== "detailsByScanAndShare" &&
                                            <div className='flex gap-5 whitespace-nowrap items-start'>
                                                {openGetOrCreatePatientModal ==="detailsByCreate" &&
                                                    <div className='relative'>
                                                        <SelectDropdown
                                                            name='updateABHADetails'
                                                            value={updateOption}
                                                            onChangeCb={(val) => {
                                                                setUpdateOption(val);
                                                                if(val.value !== "abhaAddress") dispatch(setABHASuggestionsOpen(false));
                                                                switch (val.value) {
                                                                    case 'abhaAddress':
                                                                        handleSuggestedABHAAddress();
                                                                        break;
                                                                    case 'email':
                                                                        setOpenUpdateABHAOtpRequest(true);
                                                                        break;
                                                                    case 'mobile':
                                                                        setOpenUpdateABHAOtpRequest(true);
                                                                        break;
                                                                    case 'profilePicture':
                                                                        setOpenEditProfilePicture(true);
                                                                        break;
                                                                    default:
                                                                        console.log("No action selected");
                                                                }
                                                            }}
                                                            options={ABHA_UPDATE_OPTIONS}
                                                        />
                                                         {abhaSuggestionsOpen && (
                                                            <div className="mt-4 bg-white absolute border border-gray-300 z-10 top-7 left-0 rounded-lg overflow-hidden">
                                                                <div className='flex justify-end '>
                                                                    <div onClick={() => {
                                                                            dispatch(setABHASuggestionsOpen(false))
                                                                            setUpdateOption({ label: "Select update option", value:""})
                                                                        }} 
                                                                        className=" flex justify-end items-center text-xl pt-2 px-2 hover:cursor-pointer"
                                                                    >
                                                                        <Icons iconName={"closeIcon"}/>
                                                                    </div>
                                                                </div>
                                                                <div className="flex px-4 ">
                                                                    <Checkbox
                                                                        checked={abhaAddressUpdateOpen}
                                                                        onChangeCb={() => {
                                                                            dispatch(setABHAAddressUpdateOpen(true))
                                                                        }}
                                                                    />
                                                                    <div className="pl-1 text-gray-500 ">
                                                                        <Label fontWeight="semibold" color={"met-primary"}>Enter Manually</Label>
                                                                    </div>
                                                                </div>
                                                                <ul className=" rounded p-2 space-y-2">
                                                                    {abhaSuggestedAddress?.abhaAddressList?.length > 0 && (
                                                                        abhaSuggestedAddress.abhaAddressList.slice(0,3).map((address, index) => (
                                                                            <li
                                                                                key={index}
                                                                                className="cursor-pointer p-2 rounded hover:bg-met-primary hover:text-white"
                                                                                onClick={() => handleSelectAddress(address)}
                                                                            >
                                                                                {address}@abdm
                                                                            </li>
                                                                        ))
                                                                    )}
                                                                </ul>
                                                            </div>
                                                        )}
                                                        
                                                    </div>
                                                }
                                           
                                            </div>
                                        }
                                   {selectedABHAOption !== "Scan and Share" && 
                                     <Button
                                       variant={BUTTON_VARIANTS.CONTAINED}
                                       onClickCb={handleDownloadCard}
                                       className="text-blue-600 border-blue-600"
                                     >
                                       Download ABHA Card
                                     </Button>
                                   }
                                               
                                    </div>

                            <div className="mt-4 space-y-4">
                                <div className="flex flex-col gap-4">
                                    <div className='flex justify-between'>

                                        <div className="grid place-content-center w-full">
                                        <h3 className= " text-center font-bold mb-6 " >ABHA Data</h3>
                                             {abhaProfilePictureToDisppay ? (
                                                encodeBase64 ? (
                                                        <img
                                                            alt="ABHA Profile"
                                                            src={`data:image/png;base64,${encodeBase64}`}
                                                            className="w-[130px] h-[130px] object-cover rounded-full"
                                                        />
                                                    ) :  
                                                    <Avatar textCenter="middle"
                                                        customClass="w-[130px] h-[130px] overflow-hidden object-cover rounded-full"
                                                        fontSize={3} url={abhaProfilePictureToDisppay} name={`${firstName} ${lastName}`} 
                                                    />
                                                ) : (
                                                    <div className="w-32 h-32 border rounded-full border-gray-300 flex items-center justify-center">
                                                        <span 
                                                            className="text-met-primary text-6xl font-bold whitespace-nowrap overflow-hidden text-ellipsis"
                                                            style={{ maxWidth: '80%' }}
                                                        >
                                                            {firstName?.charAt(0).toUpperCase()}
                                                            {lastName?.charAt(0).toUpperCase()}
                                                        </span>
                                                    </div>
                                                )
                                            }
                                        </div>

                                    </div>
                                

                                <div className="grid gap-6 max-w-[420px] mx-auto mt-6 text-sm">
                                  
                                    <div>
                                        {/* <h2 className="text-lg font-semibold mb-4 text-gray-800">ABHA Data</h2> */}
                                        <p className="mb-1.5"><strong>Name:</strong> {`${firstName || '-'} ${middleName || '-'} ${lastName || '-'}`}</p>
                                        <p className="mb-1.5"><strong>Gender:</strong> {gender?.charAt(0).toUpperCase() + gender?.slice(1) || '-'}</p>
                                        <p className="mb-1.5"><strong>Address:</strong> {address||newPatientData?.address
                                        ? `${addressLine1 || '-'}, ${addressLine2 || '-'}, ${city || '-'}, ${country || '-'}`
                                        : '-'}</p>
                                        <p className="mb-1.5"><strong>State:</strong> {state || '-'}</p>
                                        <p className="mb-1.5"><strong>Pin Code:</strong> {zip || '-'}</p>
                                        <p className="mb-1.5"><strong>Mobile:</strong> {abhaMobileToDispplay || '-'}</p>
                                        <p className="mb-1.5"><strong>ABHA Address:</strong> {abhaAddressToDisplay
                                            || '-'}</p>
                                        <p className="mb-1.5"><strong>ABHA Number:</strong> {abhaNumber || '-'}</p>
                                        <p className="mb-1.5"><strong>Date of Birth:</strong> {dob ? formatDOB(dob) : '-'}</p>
                                    </div>


                           {oldPatientData&&<>                                 
                             
                             <h3 className= " text-center font-bold " >HIMS Data</h3>
                                    <div>
                                        <p className="mb-1.5"><strong>Name:</strong> {`${oldPatientData?.patient?.firstName || '-'} ${oldPatientData?.patient?.middleName || '-'} ${oldPatientData?.patient?.lastName || '-'}`}</p>
                                        <p className="mb-1.5"><strong>Gender:</strong> {oldPatientData?.patient?.gender?.charAt(0).toUpperCase() + oldPatientData?.patient?.gender?.slice(1) || '-'}</p>
                                        <p className="mb-1.5"><strong>Address:</strong> {oldPatientData?.address
                                            ? `${oldPatientData?.address?.addressLine1 || '-'}, ${oldPatientData?.address?.addressLine2 || '-'}, ${oldPatientData?.address?.city || '-'}, ${oldPatientData?.address?.country || '-'}`
                                            : '-'}</p>
                                        <p className="mb-1.5"><strong>State:</strong> {oldPatientData?.address?.state || '-'}</p>
                                        <p className="mb-1.5"><strong>Pin Code:</strong> {oldPatientData?.address?.zip || '-'}</p>
                                        <p className="mb-1.5"><strong>Mobile:</strong> {oldPatientData?.patient?.mobileNumber || '-'}</p>
                                        <p className="mb-1.5"><strong>ABHA Address:</strong> {oldPatientData?.patient?.abhaAddress || '-'}</p>
                                        <p className="mb-1.5"><strong>ABHA Number:</strong> {oldPatientData?.patient?.abhaNumber || '-'}</p>
                                        <p className="mb-1.5"><strong>Date of Birth:</strong> {oldPatientData?.patient?.dob ? formatDOB(oldPatientData?.patient?.dob) : '-'}</p>
                                    </div>
                                    </> }

                                    </div> 
                                </div>                                    
                                </div>
                                <div className="flex justify-end space-x-4 mt-6">
                                <Button
                                    variant={BUTTON_VARIANTS.CONTAINED}
                                    onClickCb={() => {
                                        if(transactionIdAndAadhaar?.via === "mobile"){
                                            handleCreateABHApatient()
                                        }else {
                                            onSubmit()
                                        }
                                        
                                    }}
                                    className="text-blue-600 border-blue-600"
                                >
                                    {oldPatientData || patient?.isNew === false ?"Update":selectedABHAOption==="Scan and Share"?"Next":"Create"}
                                </Button>
                            </div>
                            </div>



                        </div>
                                    

                    {confirmUpdateABHAAddressOpen && 
                        <UpdateABHAAddressPopup 
                            open={confirmUpdateABHAAddressOpen} 
                            close={() => {
                                setConfirmUpdateABHAAddressOpen(false)
                                //setUpdateOption({ label: "Select update option", value:""})
                            }}
                            onConfirm={() => handleUpdateABHAAddress(abhaAddressValue)}
                        />
                    }

                    {updateOption.value === "email" || updateOption.value === "mobile" ? (
                        <UpdateABHADetails
                            open={openUpdateABHAOtpRequest}
                            close={(value) => {
                                setUpdateInputValue(value);
                                setOpenUpdateABHAOtpRequest(false);
                                if(typeof value !== 'string'){
                                    setUpdateOption({ label: "Select update option", value:""})
                                }
                                
                            }}
                            updateName={updateOption.value}
                        />
                    ) : null}

                    {abhaAddressUpdateOpen &&
                        <UpdateABHAAddressModal 
                            open={abhaAddressUpdateOpen}
                            close={() => {
                                dispatch(setABHAAddressUpdateOpen(false))
                            }}
                            onConfirm = {(value) => {
                                handleUpdateABHAAddress(value)
                                setUpdateOption({ label: "Select update option", value:""})
                            }}
                        />
                    }
                    {openUpdateABHAValidateOtpModal && 
                        <UpdateABHAValidateOTPModal 
                            open={openUpdateABHAValidateOtpModal}
                            updateInputValue={updateInputValue}
                            close={() => {
                                setUpdateOption({ label: "Select update option", value:""})
                                dispatch(setOpenUpdateABHAValidateOtpModal(false))
                                setUpdateInputValue("");
                            }}
                            updateName={updateOption.value}
                        />
                    }
                    {openEditProfilePicture && 
                        <UploadProfilePictureModal 
                            open={openEditProfilePicture}
                            close={() => {
                                setUpdateOption({ label: "Select update option", value:""})
                                setOpenEditProfilePicture(false)
                            }}
                        />
                    }
                    <ModalComponent
                        open={!createABHAPatientResponse.success && createABHAPatientResponse.isPatient}
                        title={`Confirm`}
                        footerButton={
                            <div className="flex column-gap-10px mt-4">
                                
                                    <Button onClickCb={() => dispatch(setCreateABHApatientRespose({}))} variant={BUTTON_VARIANTS.OUTLINED} customBtnClass='px-4'>
                                        Cancel
                                    </Button>
                                    <Button onClickCb={() => handleCreateABHApatient(true)} customBtnClass='px-4'>
                                        Confirm
                                    </Button>
                                
                
                            </div>
                
                        }
                        icon={<Icons iconName="closeIcon" />}
                        close={close}
                        customClasses="w-[450px]"
                    >
                        <div className="m-5 text-center">
                            <div className="text-[14px] font-[500]">{createABHAPatientResponse.message}</div>
                        </div>
                    </ModalComponent>

                </>

            );
        }}
        </Formik>
    )
}

export default PatientDetailsReviewModal;
